import { render } from "./FitFollowUpDue.vue?vue&type=template&id=58f6eafc&scoped=true&lang=pug"
import script from "./FitFollowUpDue.vue?vue&type=script&lang=js"
export * from "./FitFollowUpDue.vue?vue&type=script&lang=js"

import "./FitFollowUpDue.vue?vue&type=style&index=0&id=58f6eafc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f6eafc"]])

export default __exports__